const TNavMenu = {
    // English
    "enUS": {
        'LOGOUT': 'Logout',
        'SIGN_IN': 'Own a restaurant? Sign In',
        'MY_BUSINESS': 'My Business',
        'FOOD': 'Food',
        'MENUS': 'Menu',
        'ACCOUNT': 'Account',
        'SETTINGS': 'Settings',
        'SEE_PLANS': 'See Plans',
        'UPGRADE_PLAN': 'Upgrade Plan',
        'DOWNLOAD_APPS': 'Download Apps',
        'TOKEN_MASTER': 'Tokens',
    },
    // Spanish
    "esMX": {
        'LOGOUT': 'Cerrar Sesión',
        'SIGN_IN': "¿Dueño de un restaurante? Inicia sesión",
        'MY_BUSINESS': 'Mi Negocio',
        'FOOD': 'Alimentos',
        'MENUS': 'Menús',
        'ACCOUNT': 'Cuenta',
        'SETTINGS': 'Configuración',
        'SEE_PLANS': 'Ver Planes',
        'UPGRADE_PLAN': 'Mejorar Plan',
        'DOWNLOAD_APPS': 'Descargar Apps',
        'TOKEN_MASTER': 'Tokens',
    }
}
export default TNavMenu;